import { BaseService } from "services/_baseService";
import appAxios from "services/axios";

class OffersAdminService extends BaseService<any> {
  constructor() {
    super(`offers`);
  }

  hide = async (id: number) => {
    return appAxios.post(`${this.pathWithOrg()}/${id}/hide`);
  }

  // Update offer price and stock
  updatePriceAndStock = async (id: number, data: any) => {
    return appAxios.post(`${this.pathWithOrg()}/${id}/update-price-and-stock`, data);
  }
}

export default new OffersAdminService();
